import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';

import { cloneDeep } from 'lodash';

@Component({
    selector: 'sfx-filters-group',
    templateUrl: './filters-group.component.html',
    styleUrls: ['./filters-group.component.scss'] // Optional if styles are needed
})
export class FiltersGroupComponent implements OnInit, OnChanges {

    @Input() index!: number;
    @Input() appliedGroup: any;
    @Input() fixedFilters?: boolean;
    @Input() pipeline: any;
    @Input() entity!: string;
    @Input() group!: string;
    @Input() filterFields: any[] = [];

    @Input() deleteGroup!: () => void;
    @Input() onFilterUpdate!: (args: { groupIndex: number, updatedGroups: any[] }) => void;
    @Input() onApply!: () => void;

    rules: any[] = [];
    ruleIndex = 0;

    ngOnInit(): void {
        this.initializeRules();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.appliedGroup && !changes.appliedGroup.firstChange) {
            this.initializeRules();
        }
    }

    initializeRules(): void {
        this.rules = this.appliedGroup?.filterRules ? cloneDeep(this.appliedGroup.filterRules) : [];
        this.ruleIndex = 0;

        if (this.rules.length > 0) {
            this.rules.forEach((rule, idx) => {
                rule.index = idx;
                this.ruleIndex = idx;
            });
            this.ruleIndex += 1;
        }

        if (this.ruleIndex === 0) {
            const firstRule = { index: this.ruleIndex };
            this.ruleIndex += 1;
            this.rules.push(firstRule);
        }
    }

    addFilterRule(): void {
        const newRule = {
            index: this.ruleIndex,
            disabled: false
        };
        this.rules.push(newRule);
        this.updateFilterRule(newRule.index, newRule);
        this.ruleIndex += 1;
    }

    removeFilterRule(ruleIndex: number): void {
        const index = this.rules.findIndex((rule) => rule.index === ruleIndex);
        const foundRule = this.rules[index];

        if (index !== -1) {
            this.rules.splice(index, 1);
        }

        this.onFilterUpdate({ groupIndex: this.index, updatedGroups: [...this.rules] });

        // Check if we need to apply after removal
        if (this.rules.length > 0 && foundRule?.operator) {
            this.onApply();
        }
    }

    getRemoveRuleFn(index: number): () => void {
        return () => this.removeFilterRule(index);
    }

    updateFilterRule(ruleIndex: number, newRule: any): void {
        let index = this.rules.findIndex((rule) => rule.index === ruleIndex);

        if (index === -1 && newRule.index) {
            index = newRule.index;
        }

        if (index === -1) {
            return;
        }

        if (!newRule.index) {
            newRule.index = index;
        }

        this.rules[index] = newRule;
        this.onFilterUpdate({ groupIndex: this.index, updatedGroups: [...this.rules] });
    }

    getOnRuleUpdateFn(index: number): (newRule: any) => void {
        return (newRule: any) => this.updateFilterRule(index, newRule);
    }

    delete(): void {
        this.deleteGroup();
    }

    // Dummy placeholder (as per original TODO)
    loadFilter(): void {
        // Placeholder
    }
}
